
import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', align: 'start', value: 'number_index', width: '10' },
  { text: 'Fee Name', value: 'fee_name'},
  { text: 'Sales Volume/month', value: 'sales_volume'},
  { text: 'Fee Sharing', value: 'fee_sharing'},
  { text: 'Created Date', value: 'created_at'},
  { text: 'Updated Date', value: 'updated_at'},
  { text: 'Mulai Berlaku', value: 'started_date'},
  { text: 'Action', value: 'action', align: 'center', textAlign: 'text-center', width: '10' }
]);

export const defaultItem = {
  id: '',
  fee_name: '',
  fee_sharing: '',
  volume_month_min: '',
  volume_month_max: '',
  volume_status: false,
  start_month: '',
  start_year: '',
  started_date_val: '',
};

export const editedItem = {
  id: '',
  fee_name: '',
  fee_sharing: '',
  volume_month_min: '',
  volume_month_max: '',
  volume_status: false,
  start_month: '',
  start_year: '',
  started_date_val: '',
};

export const search = {
  fee_name: '',
  fee_sharing: '',
  created_at: '',
  updated_at: '',
  start_month: '',
  start_year: '',
};

